/* Earthly Pets - theme.js
   Progressive enhancement only. Every interactive block still works with JS
   disabled: the bundle selector falls back to a native <select>, the gallery
   falls back to a stacked list of images, and the FAQ uses <details>. */

(function () {
  'use strict';

  var formatMoney = function (cents) {
    var fmt = (window.EarthlyPets && window.EarthlyPets.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  };

  /* ---------------- Mobile navigation ---------------- */

  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------------- Product gallery ---------------- */

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (src) {
            main.setAttribute('src', src);
            main.setAttribute('alt', alt);
            main.removeAttribute('srcset');
          }
          thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------------- Bundle selector ---------------- */

  function initBundles() {
    document.querySelectorAll('[data-bundle-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-variants]');
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var priceEl = form.querySelector('[data-price]');
      var compareEl = form.querySelector('[data-compare-price]');
      var submit = form.querySelector('[data-submit]');
      var options = form.querySelectorAll('[data-bundle-option]');
      var subToggle = form.querySelector('[data-subscribe-toggle]');
      var subFreq = form.querySelector('[data-subscribe-freq]');

      function variantById(id) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) return variants[i];
        }
        return null;
      }

      function applyDiscount(cents) {
        if (!subToggle || !subToggle.checked) return cents;
        var pct = parseFloat(subToggle.getAttribute('data-discount') || '0');
        return Math.round(cents * (1 - pct / 100));
      }

      // The radios carry name="id" and are submitted directly, so this only
      // has to keep the displayed price and button state in sync.
      function select(id) {
        var variant = variantById(id);
        if (!variant) return;

        if (priceEl) priceEl.innerHTML = formatMoney(applyDiscount(variant.price));

        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.innerHTML = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available
            ? submit.getAttribute('data-text-add')
            : submit.getAttribute('data-text-sold-out');
        }

        options.forEach(function (opt) {
          var input = opt.querySelector('input');
          var isMatch = input && String(input.value) === String(variant.id);
          opt.classList.toggle('is-selected', !!isMatch);
        });
      }

      options.forEach(function (opt) {
        var input = opt.querySelector('input');
        if (!input) return;
        input.addEventListener('change', function () { select(input.value); });
      });

      var planSelect = subFreq ? subFreq.querySelector('select') : null;

      function syncSubscribe() {
        if (subFreq) subFreq.classList.toggle('is-visible', subToggle.checked);
        // A one-off purchase must never submit a selling_plan, or the customer
        // is put on a subscription they did not ask for.
        if (planSelect) planSelect.disabled = !subToggle.checked;
        var checked = form.querySelector('[data-bundle-option] input:checked');
        if (checked) select(checked.value);
      }

      if (subToggle) {
        // A landing page hands its choice over on the query string.
        var params = new URLSearchParams(window.location.search);
        if (params.has('subscribe')) {
          subToggle.checked = params.get('subscribe') !== '0';
        }
        var wanted = params.get('interval');
        if (wanted && planSelect) {
          for (var i = 0; i < planSelect.options.length; i++) {
            if (planSelect.options[i].getAttribute('data-interval') === wanted) {
              planSelect.selectedIndex = i;
              break;
            }
          }
        }
        subToggle.addEventListener('change', syncSubscribe);
        syncSubscribe();
      }

      var initial = form.querySelector('[data-bundle-option] input:checked');
      if (initial) select(initial.value);
    });
  }

  /* ---------------- Landing-page purchase options ---------------- */

  // Turns "Monthly" into "monthly", the same shape Liquid's handleize filter
  // produces, so a plan name from Shopify can be matched to a dropdown value.
  function handleize(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // Landing pages are not bound to a Shopify product, so the selling plan id
  // has to be looked up from the product JSON before anything can be added.
  var planCache = {};
  function findSellingPlan(handle, wanted) {
    if (planCache[handle]) return Promise.resolve(pickPlan(planCache[handle], wanted));
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        var groups = (product && product.selling_plan_groups) || [];
        planCache[handle] = groups;
        return pickPlan(groups, wanted);
      })
      .catch(function () { return null; });
  }

  function pickPlan(groups, wanted) {
    for (var g = 0; g < groups.length; g++) {
      var plans = groups[g].selling_plans || [];
      for (var p = 0; p < plans.length; p++) {
        if (handleize(plans[p].name) === wanted) return plans[p].id;
      }
    }
    return null;
  }

  // The button on a landing page says "Add to basket", so it has to actually
  // add to the basket. The href stays correct as a no-JavaScript fallback and
  // is also where we fall back to if anything here fails.
  function initBundleOptions() {
    document.querySelectorAll('[data-bundle-options]').forEach(function (box) {
      var options = box.querySelectorAll('[data-bundle-option]');
      var cta = box.querySelector('[data-bundle-cta]');
      if (!options.length || !cta) return;

      var fallback = cta.getAttribute('data-fallback') || cta.getAttribute('href');
      var subToggle = box.querySelector('[data-subscribe-toggle]');
      var subFreq = box.querySelector('[data-subscribe-freq]');
      var interval = box.querySelector('[data-subscribe-interval]');
      var current = null;

      function withSubscription(url) {
        if (!subToggle || !url) return url;
        var q = 'subscribe=' + (subToggle.checked ? '1' : '0');
        if (subToggle.checked && interval && interval.value) {
          q += '&interval=' + encodeURIComponent(interval.value);
        }
        return url + (url.indexOf('?') === -1 ? '?' : '&') + q;
      }

      // Each tier carries both the one-off and the subscription price, so the
      // figure on screen always matches what the customer is about to be
      // charged rather than lagging the Subscribe tick box.
      function syncPrices() {
        var on = !!(subToggle && subToggle.checked);
        box.querySelectorAll('[data-bundle-price]').forEach(function (el) {
          var once = el.getAttribute('data-price-once');
          var sub = el.getAttribute('data-price-sub');
          var next = on && sub ? sub : once;
          if (next && el.textContent !== next) el.textContent = next;
        });
      }

      function apply() {
        var link = current && current.getAttribute('data-link');
        cta.setAttribute('href', withSubscription(link && link.length ? link : fallback));
        syncPrices();
      }

      function select(input) {
        current = input;
        options.forEach(function (opt) {
          opt.classList.toggle('is-selected', opt.contains(input));
        });
        apply();
      }

      options.forEach(function (opt) {
        var input = opt.querySelector('input[type="radio"]');
        if (!input) return;
        input.addEventListener('change', function () { select(input); });
      });

      if (subToggle) {
        subToggle.addEventListener('change', function () {
          if (subFreq) subFreq.classList.toggle('is-visible', subToggle.checked);
          apply();
        });
      }
      if (interval) interval.addEventListener('change', apply);

      cta.addEventListener('click', function (e) {
        var link = current && current.getAttribute('data-link');
        if (!link) return;                       // nothing bound: follow the href

        var handle = (link.match(/\/products\/([^?#]+)/) || [])[1];
        var variant = (link.match(/[?&]variant=(\d+)/) || [])[1];
        if (!handle || !variant) return;         // ditto

        e.preventDefault();
        if (cta.getAttribute('aria-busy') === 'true') return;

        var label = cta.textContent;
        cta.setAttribute('aria-busy', 'true');
        cta.classList.add('is-loading');

        function giveUp() {                      // never strand the customer
          window.location.href = link;
        }

        var wantsPlan = subToggle && subToggle.checked && interval && interval.value;
        var lookup = wantsPlan ? findSellingPlan(handle, interval.value) : Promise.resolve(null);

        lookup.then(function (planId) {
          var body = { id: Number(variant), quantity: 1 };
          if (planId) body.selling_plan = planId;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
        }).then(function (r) {
          if (!r || !r.ok) return giveUp();
          window.location.href = window.EarthlyPets.routes.cart_url;
        }).catch(giveUp)
          .then(function () {
            cta.removeAttribute('aria-busy');
            cta.classList.remove('is-loading');
            cta.textContent = label;
          });
      });

      var initial = box.querySelector('[data-bundle-option] input:checked')
        || box.querySelector('[data-bundle-option] input[type="radio"]');
      if (initial) {
        initial.checked = true;
        select(initial);
      }
    });
  }

  /* ---------------- Product tabs ---------------- */

  // Every panel is in the markup already, so the only job here is to hide the
  // ones that are not selected. The data-ready flag is what switches the CSS
  // from "show everything" to "show one", which keeps the section usable when
  // this script never runs.
  function initProductTabs() {
    document.querySelectorAll('[data-ptabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-ptab]');
      var panels = root.querySelectorAll('[data-ptab-panel]');
      if (!tabs.length || !panels.length) return;

      root.setAttribute('data-ready', 'true');

      function show(index) {
        tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-ptab') === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-ptab-panel') === index);
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          show(tab.getAttribute('data-ptab'));
        });

        // Left/right arrows move between tabs, which is what a tablist is
        // expected to do.
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var list = Array.prototype.slice.call(tabs);
          var at = list.indexOf(tab);
          var next = e.key === 'ArrowRight' ? at + 1 : at - 1;
          if (next < 0) next = list.length - 1;
          if (next >= list.length) next = 0;
          show(list[next].getAttribute('data-ptab'));
          list[next].focus();
        });
      });

      var first = root.querySelector('[data-ptab]');
      if (first) show(first.getAttribute('data-ptab'));
    });
  }

  /* ---------------- Cart count ---------------- */

  function refreshCartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    fetch(window.EarthlyPets.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      })
      .catch(function () { /* leave the server-rendered count in place */ });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initGallery();
    initBundles();
    initBundleOptions();
    initProductTabs();
    refreshCartCount();
  });
})();
